"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const OldDeeplinkResolver = (props) => {
    const { venueSlug, itemId, itemSlug, type } = props.match.params;
    let redirectTo = '';
    if (venueSlug) {
        if (!type) {
            // venue checkin
            redirectTo = `/${venueSlug}`;
        }
        else if (!itemId && !itemSlug) {
            // activity | directory | offers root
            redirectTo = `/${venueSlug}/${type}`;
        }
        else if (itemId && itemSlug) {
            // deeplink item
            switch (type) {
                case 'messages': {
                    const oldItemDate = itemId.substring(0, 9);
                    const oldItemBaseId = itemId.split(oldItemDate).pop();
                    const updatedDeeplinkId = `${oldItemDate}0000${oldItemBaseId}`;
                    redirectTo = `/${venueSlug}/activities/${itemSlug}-${updatedDeeplinkId}`;
                    break;
                }
                case 'offers':
                    redirectTo = `/${venueSlug}/offers/offer/${itemSlug}-${itemId}`;
                    break;
                case 'offers_folders':
                    redirectTo = `/${venueSlug}/offers/folder/${itemSlug}-${itemId}`;
                    break;
                default:
                    redirectTo = `/${venueSlug}/directory/${type}/${itemSlug}-${itemId}`;
                    break;
            }
        }
    }
    return (react_1.default.createElement(react_router_dom_1.Redirect, { to: {
            pathname: redirectTo,
            search: props.location.search,
        } }));
};
exports.default = OldDeeplinkResolver;
// OLD DEEPLINKS FORMAT
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/activities
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/messages/#{id}-slug
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/directory
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/:type/#{id}-#{slug}
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/offers
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/offers/#{id}-#{slug}
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/offers_folders/#{id}-#{slug}
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/brands/directory ??
// https://daily.robinson.com/venues/#{venue_id}-#{venue_slug}/brands/:type//#{id}-#{slug} ??
// https://daily.robinson.com/checkin/#{venue_id}-#{venue_slug}
